export const blockedStatusLabel = (blockedStatus) => ({
    ALL: 'sp-blocked-status.all',
    NONE: 'sp-blocked-status.none',
    NONE_SUPER_ADMIN_BLOCKED: 'sp-blocked-status.none-super-admin-blocked',
})[blockedStatus];

export const blockedStatusIconClass = (blockedStatus) => ({
    ALL: 'fa fa-lg fa-ban',
    NONE: 'far fa-lg fa-check-circle',
    NONE_SUPER_ADMIN_BLOCKED: 'fa fa-lg fa-ban',
})[blockedStatus];

export const blockedStatusTextClass = (blockedStatus) => ({
    ALL: 'text-warning',
    NONE: 'text-success',
    NONE_SUPER_ADMIN_BLOCKED: 'text-warning',
})[blockedStatus];



// WEBPACK FOOTER //
// ./src/portal/components/sp-blocked-status/sp-blocked-status.exports.js